import { weekdays } from '@/constants'
import { Zone } from '@/types'
import { Button, Chip, Group, Input, Stack, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'

type ZoneFormValues = Pick<Zone, 'name' | 'service_days'>

const DEFAULT_SERVICE_DAYS = [1, 2, 3, 4, 5]

export default function ZoneForm({
  onSubmit,
  initialValues,
  submitLabel,
}: {
  onSubmit: (zone: ZoneFormValues) => void
  initialValues?: Partial<ZoneFormValues>
  submitLabel: string
}) {
  const form = useForm<ZoneFormValues>({
    initialValues: {
      name: initialValues?.name ?? '',
      service_days: initialValues?.service_days ?? DEFAULT_SERVICE_DAYS,
    },
  })

  const serviceDayValues = form.values.service_days.map(String)
  const handleServiceDaysChange = (value: string[]) =>
    form.setFieldValue('service_days', value.map(Number).sort((first, second) => first - second))

  const isValid = form.values.name.trim().length > 0 && form.values.service_days.length > 0

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="lg">
        <TextInput
          label="Nom de la zone"
          placeholder="Paris Nord, Rive Gauche…"
          {...form.getInputProps('name')}
          required
          data-autofocus
        />

        <Input.Wrapper
          label="Jours de tournée"
          description="Les jours où le coursier dessert cette zone."
          required
        >
          <Chip.Group multiple value={serviceDayValues} onChange={handleServiceDaysChange}>
            <Group gap="xs" mt="xs">
              {weekdays.map((day) => (
                <Chip key={day.value} value={String(day.value)} size="sm">
                  {day.label}
                </Chip>
              ))}
            </Group>
          </Chip.Group>
        </Input.Wrapper>

        <Button type="submit" radius="md" fullWidth size="md" disabled={!isValid}>
          {submitLabel}
        </Button>
      </Stack>
    </form>
  )
}
